export default __webpack_public_path__ + "static/media/trafficControl.60f450fb.png";